<app-top-nav [pageActions]="navActions"></app-top-nav>

<div class="main">
  <div class="wrapper">
    <div class="global-head-column">
      <div class="global-head-row">
        <div class="page-title">EXPORT FIELD CONFIGURATION</div>
      </div>
    </div>
    <div class="message-container" i18n="@@admin.export.fields.warning">
      <p>Changing the configuration applies for ALL users.</p>
    </div>
    <div class="scroll-wrapper">
      <p-table
        #dt
        [columns]="cols"
        dataKey="id"
        [value]="tableData$() | async"
        [scrollable]="true"
        [scrollHeight]="getScrollHeight()"
      >
        <ng-template pTemplate="header" let-columns>
          <th
            *ngFor="let col of columns"
            [class.col--fieldname]="col.field == 'fieldName'"
            [class.col--caption]="col.field == 'caption'"
            [class.col--selected]="col.field == 'selected'"
          >
            <div class="status-flex">
              <div
                class="horizontal-flex"
                *ngIf="!checkSortIcon(col.field); else filterHeader"
              >
                {{ col.header }}
              </div>
              <ng-template #filterHeader>
                <div
                  class="horizontal-flex clickable"
                  [matMenuTriggerFor]="extendedFilter"
                  #menuTrigger="matMenuTrigger"
                >
                  {{ col.header }}
                  <ng-container
                    *ngIf="{
                      direction: (getFieldSort$(col.field) | async)
                    } as sort"
                  >
                    <mat-icon
                      class="sortIcon {{
                        sort.direction == 1
                          ? 'sort-ascending'
                          : 'sort-descending'
                      }}"
                      *ngIf="sort.direction"
                      >straight</mat-icon
                    >
                  </ng-container>
                  <mat-icon class="material-icons-outlined sortIcon"
                    >filter_alt</mat-icon
                  >
                  <ng-container
                    *ngIf="getFieldFilters$(col.field) | async as filters"
                  >
                    <span *ngIf="filters" class="clear-header-filters"
                      >({{ filters.length }})</span
                    >
                  </ng-container>
                </div>
                <mat-menu
                  class="column-filter-menu"
                  #extendedFilter="matMenu"
                  [hasBackdrop]="true"
                >
                  <app-column-filter
                    *ngIf="menuTrigger.menuOpen"
                    [values]="getFieldValues$(col.field) | async"
                    [template]="getFieldTemplate(col.field)"
                    [canSearch]="getFieldFilterSearch(col.field)"
                    [hasEmptyValue]="getFieldHasEmptyValue(col.field)"
                    [initialSelected]="getFieldFilters$(col.field) | async"
                    [initialSort]="getFieldSort$(col.field) | async"
                    [ignoredValues]="col.ignoredFilterValues"
                    (sort)="setSort(col.field, $event)"
                    (filter)="setFilter(col.field, $event)"
                    (closePopup)="menuTrigger.closeMenu()"
                  ></app-column-filter>
                </mat-menu>
              </ng-template>
            </div>
          </th>
          <th class="col--actions">
            <div class="clear-button">
              <button
                class="clear-button"
                mat-flat-button
                color="warn"
                (click)="clearAllFilter()"
                *ngIf="extendedFilterActive$ | async"
              >
                clear all
              </button>
            </div>
          </th>
        </ng-template>
        <ng-template pTemplate="body" let-exportfield>
          <tr [pEditableRow]="exportfield">
            <td class="col--fieldname">
              {{ exportfield.fieldName }}
            </td>
            <td class="col--caption">
              {{ exportfield.caption }}
            </td>
            <td class="col--selected">
              <div style="display: flex; flex-direction: row">
                <p-inputSwitch
                  (onChange)="changeExportFieldSetting(exportfield)"
                  [(ngModel)]="exportfield.selected"
                ></p-inputSwitch>
                <div
                  *ngIf="canShowStateInfo(exportfield)"
                  style="padding-left: 10px"
                >
                  <mat-icon
                    *ngIf="
                      exportfield && exportfield.state == saveStates.ongoing
                    "
                    >autorenew</mat-icon
                  >
                  <mat-icon
                    class="red-icon"
                    *ngIf="
                      exportfield && exportfield.state == saveStates.failed
                    "
                    >autorenew</mat-icon
                  >
                  <mat-icon
                    class="green-icon"
                    *ngIf="exportfield && exportfield.state == saveStates.done"
                    >autorenew</mat-icon
                  >
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
